

import LoginPage from './identity/LoginPage';
import AcceptInvitePage from './identity/AcceptInvitePage';
import ForgotPasswordPage from './identity/ForgotPasswordPage';
import ResetPasswordPage from './identity/ResetPasswordPage';
import BootstrapAdminPage from './identity/BootstrapAdminPage';



import SettingsPage from './domain/SettingsPage';
import UsersPage from './domain/UsersPage';


const Factory = {

  Meta: {

    'LoginPage': LoginPage,
    'AcceptInvitePage': AcceptInvitePage,
    'ForgotPasswordPage': ForgotPasswordPage,
    'ResetPasswordPage': ResetPasswordPage,
    'BootstrapAdminPage': BootstrapAdminPage,

  },

  Data: {

    'SettingsPage': SettingsPage,
    'UsersPage': UsersPage,

  }

};

export default Factory;
